/**
 * Application configuration utility
 * Centralizes access to environment variables with defaults and type safety
 */

export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://prodmembersapi.holycross.ke/api',
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 10000,
    retryAttempts: Number(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
  },

  // Application Configuration
  app: {
    title: import.meta.env.VITE_APP_TITLE || 'HCC Members Portal',
    version: import.meta.env.VITE_APP_VERSION || '3.1.0',
    buildVersion: import.meta.env.VITE_APP_BUILD_VERSION || 'development',
    includeDemos: import.meta.env.VITE_APP_INCLUDE_DEMOS === 'true',
    routerModeHistory: import.meta.env.VITE_APP_ROUTER_MODE_HISTORY !== 'false',
  },

  // Google Tag Manager Configuration
  gtm: {
    enabled: import.meta.env.VITE_APP_GTM_ENABLED === 'true',
    key: import.meta.env.VITE_APP_GTM_KEY || '',
  },

  // Session Configuration
  session: {
    timeout: Number(import.meta.env.VITE_SESSION_TIMEOUT) || 15 * 60 * 1000, // 15 minutes
  },

  // Feature Flags
  features: {
    enableDevTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',
    enableConsoleLogs: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true',
  },

  // UI Configuration
  ui: {
    defaultTheme: import.meta.env.VITE_DEFAULT_THEME || 'light',
    enableThemeSwitcher: import.meta.env.VITE_ENABLE_THEME_SWITCHER !== 'false',
  },

  // Security Settings
  security: {
    enableCsrfProtection: import.meta.env.VITE_ENABLE_CSRF_PROTECTION === 'true',
    secureCookies: import.meta.env.VITE_SECURE_COOKIES === 'true',
  },

  // Environment helpers
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const

export default config
